import type { Communications } from "@/src/gql/graphql";
import { COMMUNICATIONS_CONFIG } from "@/features/tasks/components/CommunicationsConfig";
import { COMMUNICATIONS_DETAIL_CONFIG } from "@/features/tasks/components/CommunicationsDetailConfig";
import { getFieldValue } from "@/components/shared/UniversalCRMTable/components/SimpleTable/tableCellFieldValue";
import { defineEntity } from "../types";

// ============================================================================
// COMMUNICATIONS ENTITY DEFINITION
// ============================================================================
// Communications live in features/tasks/ — same feature, separate entity.
// Column change: edit features/tasks/components/CommunicationsConfig.ts fields.
// ============================================================================

export const communicationsEntity = defineEntity<Communications>({
  tableConfig: COMMUNICATIONS_CONFIG,

  detailConfig: COMMUNICATIONS_DETAIL_CONFIG,

  synthesizeField(item, fieldId) {
    return getFieldValue(item, fieldId);
  },
});
